import React from 'react';
import { Avatar, AvatarProps } from '@chakra-ui/react';
import { AvatarColors } from 'types/profile';
import { ReactComponent as UserSolidIcon } from 'resources/images/user-solid.svg';

export interface ChakraAvatarProps extends AvatarProps {
  initials?: string;
  guid?: string;
  className?: string;
  src?: string;
  colors?: AvatarColors;
}

export const ChakraAvatar: React.FC<ChakraAvatarProps> = ({
  className,
  initials,
  src = '',
  colors,
  ...avatarProps
}) => {
  const showDefault = (!src && initials === undefined) || !colors;
  return (
    <Avatar
      className={className}
      src={src}
      name={showDefault ? undefined : initials}
      icon={<UserSolidIcon color="rgba(0,0,0,0.26)" width="80%" height="80%" />}
      getInitials={() => initials || ''}
      data-testid="initials"
      data-theme-props={{
        showDefault,
        colors,
      }}
      bg={showDefault ? undefined : colors.background}
      color={showDefault ? undefined : colors.text}
      alignItems={showDefault ? 'end' : 'center'}
      ignoreFallback={Boolean(initials)}
      {...avatarProps}
    />
  );
};
